import { useState } from 'react';
import { useDeliverEvent } from '@ion/api';

export default function useEditorServerResponse({ clusterId, deliverIntegration, playbookOutput, originalEvent }) {
  const [sendEventConfirmed, setSendEventConfirmed] = useState(false);
  const [executeDeliverEvent, deliverEventResponse] = useDeliverEvent();

  const onConfirmSendEvent = () => {
    setSendEventConfirmed(true);
    // Guard so a live event is only ever sent once per chain run.
    if (!deliverEventResponse.called) {
      executeDeliverEvent({
        clusterId,
        integration: deliverIntegration,
        inputEvent: playbookOutput.outputEvent,
        originalEvent,
      });
    }
  };

  const reset = () => {
    setSendEventConfirmed(false);
    deliverEventResponse.reset();
  };

  return { ...deliverEventResponse, sendEventConfirmed, onConfirmSendEvent, reset };
}
